import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core'
import {FormBuilder, FormGroup, Validators} from '@angular/forms'

@Component({
  selector: 'dmmp-campus-location-filter',
  templateUrl: './campus-location-filter.component.html'
})
export class CampusLocationFilterComponent implements OnInit, OnChanges {

  @Input() module: any
  @Input() identifier: String
  @Input() defaultClass: String = 'campus-location-filter'
  @Input() branches: Array<any> = []
  @Output() redirectPage = new EventEmitter()
  mapsConfig: any
  marks: Array<any> = []
  filterButtons: Array<any> = []
  filterButtonsMarks: Array<any> = []
  searchFilterResult: Array<any> = []
  addressTitle: String = 'Dirección'
  contactTitle: String = 'Contacto'
  scheduleTitle: String = 'Horario de atención'
  placeholderInput: String  = 'Ingresa una dirección, ciudad o nombre'
  selectedResult
  searchGroup: FormGroup

  constructor(
    private formBuilder: FormBuilder
  ) {
    this.searchGroup = this.formBuilder.group({
      search: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    this.configMap(this.module?.maps_latitude, this.module?.maps_longitude)
    this.searchFilterResult = []

    this.module?.maps_campus_type_values?.split(',').forEach((filterItem) => {
      this.filterButtons.push({
        filter: filterItem.trim(),
        name: filterItem.trim() === 'branch' ? 'Sedes' : (filterItem.trim() === 'center' ? 'Centros' : 'Virtual'),
        active: false
      })
    })

    this.showAllMarks()
  }

  ngOnChanges() {
    this.showAllMarks()
  }

  configMap(latitude, longitude) {
    this.mapsConfig = {
      center: {
        lat: latitude ? parseFloat(latitude) : 0,
        lng: longitude ? parseFloat(longitude) : 0
      },
      zoom: this.module?.maps_zoom ? parseFloat(this.module?.maps_zoom) : 5 // Zoom default
    }
  }

  showAllMarks() {
    this.branches?.forEach((branchItem) => {
      this.marks?.push(this.buildMarkItem(branchItem))
    })
  }

  onSubmit() {
    if (this.searchGroup?.value?.search && this.searchGroup?.value?.search?.length > 0) {
      this.searchFilterResult = []
      if (this.filterButtonsMarks?.length > 0) {
        this.filterButtonsMarks?.forEach(resultItem => {
          const reg = new RegExp(this.searchGroup?.value?.search, 'gi')
          if (((resultItem?.title || '') + (resultItem?.street ? ' - ' + resultItem?.street?.toUpperCase() : '')).search(reg) !== -1) {
            const filterResultItem = {...resultItem}
            filterResultItem.filterTitle = ((filterResultItem?.title || '')
              + (filterResultItem?.street ? ' - ' + filterResultItem?.street?.toUpperCase() : '')).replace(reg, `<b>${this.searchGroup?.value?.search}</b>`)
            this.searchFilterResult.push(filterResultItem)
          }
        })
      } else {
        this.branches?.forEach(resultItem => {
          const reg = new RegExp(this.searchGroup?.value?.search, 'gi')
          if (((resultItem?.title || '') + (resultItem?.street ? ' - ' + resultItem?.street?.toUpperCase() : '')).search(reg) !== -1) {
            const filterResultItem = {...resultItem}
            filterResultItem.filterTitle = ((filterResultItem?.title || '')
              + (filterResultItem?.street ? ' - ' + filterResultItem?.street?.toUpperCase() : '')).replace(reg, `<b>${this.searchGroup?.value?.search}</b>`)
            this.searchFilterResult.push(filterResultItem)
          }
        })
      }
    } else {
      this.searchFilterResult = []
    }
  }

  filter(filterType) {
    this.searchFilterResult = []
    this.filterButtonsMarks = []
    this.formReset()
    if (filterType === '') {
      this.showAllMarks()
    } else {
      this.marks = []
      this.filterButtons?.forEach((filterButton) => {
        if (filterButton?.filter !== filterType?.filter) {
          filterButton.active = false
        }
      })
      this.branches?.forEach((branchItem) => {
        if (branchItem?.campus_type === filterType?.filter) {
          this.filterButtonsMarks.push(branchItem)
          this.marks?.push(this.buildMarkItem(branchItem))
        }
      })
    }
  }

  buildMarkItem(branchObject) {
    switch (branchObject?.campus_type) {
      case 'center': {
        return ({
          id: branchObject?.id,
          type: branchObject?.campus_type,
          lat: parseFloat(branchObject?.latitude),
          lng: parseFloat(branchObject?.longitude),
          title: branchObject?.title,
          link: null,
          target: null,
          pinUrl: './assets/images/21-pin.png'
        })
      }
      default: {
        return ({
          id: branchObject?.id,
          type: branchObject?.campus_type,
          lat: parseFloat(branchObject?.latitude),
          lng: parseFloat(branchObject?.longitude),
          title: branchObject?.title,
          link: null,
          target: null,
          pinUrl: './assets/images/house-pin.png'
        })
      }
    }
  }

  selectBranchOrCampus(itemSelected) {
    this.selectedResult = itemSelected
    this.configMap(itemSelected?.latitude, itemSelected?.longitude)
    this.marks.forEach((markItem) => {
      if (markItem?.id !== itemSelected?.id) {
        markItem.pinUrl = this.selectMarkColor(markItem, true)
      } else {
        markItem.pinUrl = this.selectMarkColor(markItem, false)
      }
    })
  }

  selectMarkColor(mark, lightMode) {
    switch (mark?.type) {
      case 'center': {
        return lightMode ? './assets/images/21-pin-light.png' : './assets/images/21-pin.png'
      }
      default: {
        return lightMode ? './assets/images/house-pin-light.png' : './assets/images/house-pin.png'
      }
    }
  }

  goBack() {
    this.selectedResult = null
    this.marks.forEach((markItem) => {
      markItem.pinUrl = this.selectMarkColor(markItem, false)
    })
  }

  formReset() {
    this.searchGroup.reset()
    this.searchFilterResult = []
  }

  campusChange(selectedCampus) {
    this.selectBranchOrCampus(this.branches.find(branchItem => branchItem?.id === selectedCampus?.id))
  }

}
